import { AppNS } from 'app';
import { useAuthQuery } from 'app/api_v2/auth/queries';
import { SplashScreen } from 'app/ui/components/SplashScreen';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface CannotBeLoggedInGuardProps {
  children: React.ReactNode;
}

export const CannotBeLoggedInGuard = (props: CannotBeLoggedInGuardProps) => {
  const { children } = props;
  const { state }: { state: AppNS.Params } = useLocation();
  const { isLoading, isSuccess, data } = useAuthQuery();

  if (isLoading) {
    return <SplashScreen />;
  }

  if (isSuccess && data) {
    if (state?.referrer) {
      return <Navigate to={{ pathname: state.referrer }} state={{ referrer: '' }} />;
    }
    return <Navigate to={'/dashboard'} />;
  }

  return <>{children}</>;
};

export default CannotBeLoggedInGuard;
